import { CUSTOM_CERT_ID } from './medicalCertificates';

type Props = {
    selectedCertificate?: string;
    onContinue: () => void;
};

const MakeYourOwnCert: React.FC<Props> = (props: Props) => {
    return (
        <div>
            <div
                className={`border border-darwin-neutral-100 ${
                    props.selectedCertificate === CUSTOM_CERT_ID ? 'bg-darwin-primary-100' : ''
                } p-8 rounded-8 text-center cursor-pointer min-h-108 bg-darwin-primary-100`}
                onClick={props.onContinue}
            >
                <p className="font-700 text-white bg-darwin-primary-200 w-32 h-32 mt-6 mb-5 m-auto flex items-center justify-center rounded-full">
                    <svg
                        className="w-14 h-13 fill-darwin-primary-500"
                        viewBox="0 0 14 13"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path d="M12.5547 1.83594L11.6641 0.945312C11.3828 0.664062 10.9844 0.5 10.6094 0.5C10.2344 0.5 9.83594 0.664062 9.55469 0.945312L1.72656 8.77344C1.65625 8.82031 1.63281 8.89062 1.60938 8.96094L1 12.0312C0.953125 12.2891 1.14062 12.5 1.35156 12.5C1.375 12.5 1.42188 12.5 1.44531 12.5L4.51562 11.8906C4.58594 11.8672 4.65625 11.8438 4.72656 11.7734L12.5547 3.94531C13.1406 3.35938 13.1406 2.42188 12.5547 1.83594ZM4.07031 10.8359L2.3125 11.1875L2.66406 9.42969L3.25 8.84375V10.25H4.65625L4.07031 10.8359ZM4.375 9.125V7.71875L8.5 3.59375L9.92969 5L5.78125 9.125H4.375Z"></path>
                    </svg>
                </p>
                <p className="text-darwin-primary-500">Make your own</p>
            </div>
        </div>
    );
};

export default MakeYourOwnCert;
